import { Component } from '@angular/core';

@Component({
  selector: 'app-customer-sales-summary',
  standalone: false,
  
  templateUrl: './customer-sales-summary.component.html',
  styles: ``
})
export class CustomerSalesSummaryComponent {

}
